module.exports = __webpack_public_path__ + "static/media/Intergalactic-a-collaboration-with-wendi-y-anderson-sm-12.ba48a1f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intergalactic/Intergalactic-a-collaboration-with-wendi-y-anderson-sm-12.jpg
// module id = 4176
// module chunks = 15